// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-content {
  background: white;
  padding: 20px 30px;
  border-radius: 12px;
  text-align: center;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

/* Table ko compact banane ke liye */
.category-container table {
  border-collapse: collapse;
  width: 100%;
}

.category-container th,
.category-container td {
  padding: 6px 10px;
  /* 👈 pehle zyada hota hai, ab kam */
  font-size: 14px;
  /* 👈 font thoda chota */
  line-height: 1.2;
}

.category-container tr {
  height: 36px;
  /* 👈 row height kam kar di */
}

.category-container thead th {
  font-weight: 600;
}

/* Status badge ko bhi compact kar do */
.status-badge {
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 12px;
  display: inline-block;
}

.compact-table th,
.compact-table td {
  padding: 6px 10px;
  font-size: 14px;
}

.compact-table tr {
  height: 36px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  /* 👈 right align */
  align-items: center;
  margin-top: 15px;
  gap: 10px;
}

.pagination button {
  padding: 6px 12px;
  border: 1px solid #ccc;
  background: #f4f4f4;
  cursor: pointer;
  border-radius: 5px;
}

.pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.pagination span {
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/pages/Faq/FaqList/FaqList.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,yCAAyC;AAC3C;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,oCAAoC;EACpC,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.modal-content {\n  background: white;\n  padding: 20px 30px;\n  border-radius: 12px;\n  text-align: center;\n  max-width: 400px;\n  width: 90%;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n/* Table ko compact banane ke liye */\n.category-container table {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.category-container th,\n.category-container td {\n  padding: 6px 10px;\n  /* 👈 pehle zyada hota hai, ab kam */\n  font-size: 14px;\n  /* 👈 font thoda chota */\n  line-height: 1.2;\n}\n\n.category-container tr {\n  height: 36px;\n  /* 👈 row height kam kar di */\n}\n\n.category-container thead th {\n  font-weight: 600;\n}\n\n/* Status badge ko bhi compact kar do */\n.status-badge {\n  padding: 3px 8px;\n  border-radius: 6px;\n  font-size: 12px;\n  display: inline-block;\n}\n\n.compact-table th,\n.compact-table td {\n  padding: 6px 10px;\n  font-size: 14px;\n}\n\n.compact-table tr {\n  height: 36px;\n}\n\n.pagination {\n  display: flex;\n  justify-content: flex-end;\n  /* 👈 right align */\n  align-items: center;\n  margin-top: 15px;\n  gap: 10px;\n}\n\n.pagination button {\n  padding: 6px 12px;\n  border: 1px solid #ccc;\n  background: #f4f4f4;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.pagination button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.pagination span {\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
